import React, { Component } from "react";
import axios from "axios";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { saveAs } from 'file-saver';
import { TextBox } from "../../Components/InputElements";
import { currentDateAndTime,decodeData } from "../../Constants/constants";

class Documents extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      loadingList: false,
      postLoading: false,
      documents: [],
      document_info: [],
      DownloadDocument: [],
      documents_data: [],
      letters: [],
      salaries: [],
      doc_title:"",
      doc_url:"",
      viewDocument:false,
      decodedData: []
    };
  }

  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  
   componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  RemarkDocument = (employee_id, row) => {
    Swal.fire({
      title: "Submit Remark",
      input: "text",
      inputValue: row.document_remark,
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_id: employee_id,
          employee_document_id: row.employee_document_id,
          document_remark: result.value,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/RemarkDocument`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
            });
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };
  handleRowInputChange = (e, idx) => {
    const { value } = e.target; 
    const updatedDocumentsData = [...this.state.documents_data]; 
    const updatedErrorData = [...this.state.errors]; 
  

    updatedDocumentsData[idx] = {
      ...updatedDocumentsData[idx], 
      document_number: value,

    };
    updatedErrorData[idx] = {
      ...updatedErrorData[idx], 
      document_number: "",

    };
  
    this.setState({ documents_data: updatedDocumentsData, errors: updatedErrorData },()=>{ console.log(this.state.documents_data); }); 
  };
  // VerifyDocument = (employee_document_id) => {
  //   const employee_id = this.props.params.employee_id;
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, Verified it!",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       var formData = {
  //         employee_document_id: employee_document_id,
  //         employee_id: employee_id,
  //       };
  //       console.log(formData);
  //       const { apiHeaderJSON, apiURL } = this.context;
  //       const headers = apiHeaderJSON;

  //       axios
  //         .post(`${apiURL}Employees/VerifyDocument`, formData, { headers })
  //         .then((response) => {
  //           console.log("response", response);
  //           this.GetList();
  //           Swal.fire({
  //             title: `<strong>${response.data.message}</strong>`,
  //             icon: "success",
  //           });
  //         })
  //         .catch((error) => {
  //           console.error("Error:", error);
  //         });
  //     }
  //   });
  // };
  VerifyDocument = (row, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type==="2"? "verify":"Unverify"} this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type==="2"? "verify":"Unverify"} it!`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          employee_document_id: row?.employee_document_id,
          guest_employee_id: this.state.data,
          employee_document_status: type,
          date: currentDateAndTime(),
        };
        console.log(formData);
        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/VerifyEmployeeDocument`, formData, {
            headers,
          })
          .then((response) => {
            console.log("response", response);
            if (response?.data?.success === true) {
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
              this.setState({ loadingList: false }, () => {
                this.GetList();
                this.props.callBack();
              });
            } else {
              this.setState({ loadingList: false }, () => {});
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };
  UnVerifyDocument = (employee_document_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, UnVerified it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_document_id: employee_document_id,
        };

        const { apiHeaderJSON, apiURL } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}Employees/UnVerifyDocument`, formData, { headers })
          .then((response) => {
            this.GetList();
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: "success",
            });
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  handleFileUpload = (event, row) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("employee_document_id", row.employee_document_id);

    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    axios
      .post(
        `${apiURL}Employees/UploadEmployeeDocument`,
        formData,
        { headers }
      )
      .then((response) => {
        Swal.fire({
          title: `<strong>${response.data.message}</strong>`,
          icon: "success",
        });
        this.GetList();
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };


  GetList = () => {
    const { apiHeaderJSON, apiURL } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;


    axios
      .get(
        `${apiURL}Employees/GetProfile?employee_id=${employee_id}`,
        { headers }
      )
      .then((response) => {
        var data = response.data.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.documents || [],
            documents_data: data.documents || [],
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  DownloadDocument = (employee_document_id, event) => {
    event.preventDefault();

  };

  render() {
    const { rows, loadingList } = this.state;
    return loadingList === true ? (
      <center>Loading...</center>
    ) : (
      <div className="">
        <div>
          <div className="card">
            <div className="card-body">
              <div class="card-header  ">
                <h6
                  className="card-title mb-0 text-center"
                >
                  DOCUMENTS
                </h6>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="table-responsive">
                    <table className="table table-borderless text-center table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th scope="col" className="text-start">
                            File Name
                          </th>
                          <th scope="col">Document ID Number</th>
                          {/* <th scope="col">Remark</th> */}
                          <th scope="col">Status</th>
                          <th scope="col">Upload</th>
                          <th scope="col">Verified</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row,idx) => (
                          <tr key={row.employee_document_id}>
                                <td>
                                <div className="d-flex align-items-center">
                              {row.employee_document_url ? (
                                <div
                                  onClick={() => {
                                    this.setState({
                                      doc_title:
                                        row.employee_document_type_title,
                                      doc_url: row.employee_document_url,
                                      viewDocument: true,
                                    });
                                  }}
                                  className="avatar-sm cursorPointer"
                                >
                                  <div
                                    style={{ color: "blue" }}
                                    className="avatar-title text-primary bg-info-subtle text-danger rounded fs-20"
                                  >
                                    <i className="ri-eye-fill text-primary" />
                                  </div>
                                </div>
                              ) : (
                                <div className="avatar-sm">
                                  <div className="avatar-title bg-danger-subtle text-danger rounded fs-20">
                                    <i className="ri-file-3-fill" />
                                  </div>
                                </div>
                              )}
                              <div className="ms-3 flex-grow-1">
                                <h6 className="fs-15 mb-0 text-start">
                                  <p className=" mb-0">
                                    {row.employee_document_type_title}
                                  </p>
                                  <div
                                    className=""
                                    style={{
                                      width: "200px",
                                      height: "24px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <h6
                                      className="text-truncate mb-0"
                                      style={{
                                        maxWidth: "11rem", // Adjust max width to fit within the parent div
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {row.employee_document_url?.split(
                                        "/"
                                      )[
                                        row.employee_document_url?.split(
                                          "/"
                                        )?.length - 1
                                      ] || "--"}
                                    </h6>
                                  </div>
                                </h6>
                              </div>
                            </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                  <input
                                  type="text"
                                  id="document_number"
                                  name="document_number"
                                  label="document_number"
                                  className=" py-1 px-2"
                                  placeholder="Enter ID Number"
                                  disabled={!this.state.documents_data[idx]?.document_file}
                                  value={this.state.documents_data[idx]?.document_number || row?.employee_document_uid}
                                  onChange={(e)=> this.handleRowInputChange(e,idx,row)}
                                  />
                                </div>
                              </td>
                            {/* <td>
                              <button
                                type="button"
                                className={`${row.document_status_label === "Verified" || row.document_status_label === "Pending" ? "disabled" : ""} btn btn-light btn-sm btn-label waves-effect right waves-light`}
                                onClick={() =>
                                  this.RemarkDocument(
                                    this.props.params.employee_id,
                                    row
                                  )
                                }
                              >
                                <i className="bx bx-info-circle label-icon align-middle fs-16 ms-2" />
                                Remark
                              </button>
                            </td> */}
                            <td>
                              <span
                                className={`badge bg-${row.document_status_color}`}
                              >
                                {row.document_status_label}
                              </span>
                            </td>
                            <td>
                              <input
                                type="file"
                                id={`fileInput-${row.employee_document_id}`}
                                style={{ display: "none" }}
                                onChange={(e) =>
                                  this.handleFileUpload(e, row)
                                }
                                accept="image/png, image/jpg, image/jpeg"
                              />
                              {row.document_status_label === "Uploaded" ? (
                                <>
                                  <label
                                    htmlFor={`fileInput-${row.employee_document_id}`}
                                    className="btn btn-secondary btn-sm btn-label waves-effect waves-light"
                                  >
                                    <i className="ri-file-upload-line label-icon align-middle fs-16 me-2" />
                                    Change
                                  </label>
                                </>
                              ) : (
                                <>
                                  <label
                                    htmlFor={`fileInput-${row.employee_document_id}`}
                                    className={`${row.document_status_label === "Verified" ? "disabled" : ""} btn btn-primary btn-sm btn-label waves-effect waves-light`}
                                  >
                                    <i className={`ri-file-upload-line label-icon align-middle fs-16 me-2`} />
                                    Upload
                                  </label>
                                </>
                              )}
                            </td>
                            <td>
                              {/* <button
                                type="button"
                                className={`${row.document_status_label === "Pending" ? "disabled" : " "} btn btn-success btn-sm btn-label waves-effect right waves-light`}
                                onClick={() => this.VerifyDocument(row.employee_document_id)} >
                                <i className=" ri-check-double-line label-icon align-middle fs-16 ms-2" />
                                Verify
                              </button> */}

                                {row.document_status_label === "Verified" ? (
                                  <>
                                    <button
                                      type="button"
                                      className={`${
                                        row.document_status_label === "Pending"
                                          ? "disabled"
                                          : " "
                                      } btn btn-secondary btn-sm btn-label waves-effect right waves-light`}
                                      onClick={() =>
                                        this.VerifyDocument(row, "3")
                                      }
                                    >
                                      <i className="ri-close-line label-icon align-middle fs-16 ms-2" />
                                      Unverify
                                    </button>
                                  </>
                                  ) : (
                                  <>
                                    <button
                                      type="button"
                                      className={`${
                                        row.document_status_label === "Pending"
                                          ? "disabled"
                                          : " "
                                      } btn btn-success btn-sm btn-label waves-effect right waves-light`}
                                      onClick={() =>
                                        this.VerifyDocument(row, "2")
                                      }
                                    >
                                      <i className=" ri-check-double-line label-icon align-middle fs-16 ms-2" />
                                      Verify
                                    </button>
                                  </>
                                  )} 
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {this.state.viewDocument && (
                <div
                  id="myModal"
                  className="modal show"
                  tabIndex={-1}
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                  aria-labelledby="myModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className=" bg-light m-auto mt-3"
                    style={{ width: "70%" }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="myModalLabel">
                          Document
                        </h5>

                        <button
                          onClick={() => {
                            this.setState({
                              viewDocument: false,
                              doc_title: "",
                              doc_url: "",
                            });
                          }}
                          className="btn-close"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div
                        style={{ padding: "0 10px 10px 0" }}
                        className="modal-body"
                      >
                        <div className="row">
                          <div
                            className="mb-4 m-auto p-1 rounded-2 grayBlurShadow"
                            style={{ width: "80%" }}
                          >
                            <h3 className="text-center">
                              {this.state.doc_title}
                            </h3>
                            <div
                              className="m-auto rounded-3 overflow-hidden"
                              style={{
                                width: "100%",
                                height: "600px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {this.state.doc_url?.includes("pdf") ? (
                                <iframe
                                  src={this.state.doc_url}
                                  title="PDF Viewer"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  frameBorder="0"
                                >
                                  This browser does not support embedded
                                  files.
                                </iframe>
                              ) : (
                                <img
                                  src={this.state.doc_url}
                                  style={{
                                    width: "100%",
                                    // height: "100%",
                                  }}
                                  alt="document_image"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          onClick={() => {
                            this.setState({
                              viewDocument: false,
                              doc_title: "",
                              doc_url: "",
                            });
                          }}
                          className="btn btn-light"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Documents);
